import { Fragment } from 'react/jsx-runtime';
import { safeJson } from '@/scripts/utils';
import SysText from '../../sysText';

const GroupInviteMessage = memo(
  ({ payload, noStyle }: { payload: string; noStyle?: boolean }) => {
    const { user_name, member } = safeJson(payload, {} as any);
    return (
      <SysText noStyle={noStyle}>
        <Trans
          components={{
            name: <a />,
            members: (
              <>
                {member?.map((item: any, index: number) => (
                  <Fragment key={index}>
                    {index > 0 && ', '}
                    <a>{item.user_name}</a>
                  </Fragment>
                ))}
              </>
            ),
          }}
          values={{
            name: user_name,
          }}
          i18nKey="messages.chat.message.group.groupInvite"
        />
      </SysText>
    );
  }
);
export default GroupInviteMessage;
